var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.313 16.875H3.727a.59.59 0 0 1-.602-.602V9.688A7.19 7.19 0 0 1 10.313 2.5v0A7.187 7.187 0 0 1 17.5 9.688v0a7.187 7.187 0 0 1-7.187 7.187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M10.313 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M6.563 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M14.063 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
  })));
};
export default SvgChatBubble;